module.exports = __webpack_public_path__ + "img/couples-008.a1485e3d.jpg";